<template>
    <base-modal hide-footer hide-header size="lg" @close="$emit('close')">
        <div class="col-12">
            <h3 v-if="!bin || !bin.id" class="editor-header">
                {{ $t('mixed_waste_bins.add') }}
            </h3>
            <h3 v-else class="editor-header">
                {{ $t('mixed_waste_bins.edit') }}
            </h3>
        </div>
        <div class="col-sm-12 nopads" @click.stop="null">
            <div v-if="bin" class="col-sm-12 container editor-form">
                <div class="col-12">
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-3">
                        <span class="span-title">
                             {{ $t('mixed_waste_bins.id') }}
                        </span>
                        <div v-if="bin && bin.id">
                            <span>{{ bin.id }}</span>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.location') }}</span>
                  <!--       <div v-if="bin.id && bin.id > 0" class="nopads">
                            <div>{{ bin.osoite_id.osoitenumero }} {{ bin.osoite_id.postitoimipaikan_nimi }}</div>
                        </div>-->
                      <!--  <span v-else style="font-size: .85em">{{ coordinate.lat.toFixed(6) + ' ' + coordinate.lng.toFixed(6) }}</span> -->
                        <span  style="font-size: .85em">{{ position.lat.toFixed(6) + ' ' + position.lng.toFixed(6) }}</span>
                        <!-- <span style="font-size: .85em">koordinates here </span> -->
                    </div>
                    <div class="col-sm-3 hidden">
                        <span class="span-title">{{ $t('mixed_waste_bins.direction') }}</span>
                        <input
                            id="direction"
                            v-model="bin.direction"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3 hidden">
                        <span class="span-title">{{ $t('mixed_waste_bins.choose_location_uncertainty') }} </span>
                        <select
                            id="locationUncertainty"
                            v-model="bin.location_uncertainty_id"
                            class="form-select form-select-sm"
                        >
                            <option :value="null">{{ $t('mixed_waste_bins.location_uncertainty') }}</option>
                            <option v-for="status in getLocationUncertaintyTypes()" :key="status.value" :value="status.value">{{ status.name }}</option>
                        </select>
                    </div>
                </div>
                <hr>
                <h4 class="form-header pointer hover-header" @click.stop="basicInfoVisible = !basicInfoVisible"> {{ $t('contracts.basic_info')}} </h4>
                <div class="row">
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.manufacturer') }}</span>
                        <input
                            id="manufacturer"
                            v-model="bin.manufacturer"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.model') }}</span>
                        <input
                            id="model"
                            v-model="bin.model"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.completion_year') }}</span>
                        <input
                            id="completionYear"
                            v-model="bin.completion_year"
                            type="number"
                            step="1"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.renovation_year') }}</span>
                        <input
                            id="renovation_year"
                            v-model="bin.renovation_year"
                            type="number"
                            step="1"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.owner') }}</span>
                        <input
                            id="owner"
                            v-model="bin.owner"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.holder') }}</span>
                        <input
                            id="holder"
                            v-model="bin.holder"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.maintainer') }}</span>
                        <input
                            id="maintainer"
                            v-model="bin.maintainer"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <hr>
                <h4 class="form-header pointer hover-header" @click.stop="detailsVisible = !detailsVisible">{{ $t('mixed_waste_bins.details') }}</h4>
                <div class="row">
                        <div class="col-sm-3">
                            <span class="span-title">{{ $t('mixed_waste_bins.material') }}</span>
                            <select
                                id="binmaterial"
                                v-model="bin.material_id"
                                class="form-select form-select-sm"
                            >
                                <option :value="null">{{ $t('mixed_waste_bins.choose_material') }}</option>
                                <option v-for="status in getInfraEquipmentMaterials()" :key="status.value" :value="status.value">{{ status.name }}</option>
                            </select>
                        </div>
                        <div class="col-sm-3">
                            <span class="span-title">{{ $t('mixed_waste_bins.equipment_lifecycle') }}</span>
                            <select
                                id="binlifecycle"
                                v-model="bin.equipment_lifecycle_id"
                                class="form-select form-select-sm"
                            >
                                <option :value="null">{{ $t('mixed_waste_bins.choose_equipment_lifecycle') }}</option>
                                <option v-for="status in getInfraEquipmentLifeCycle()" :key="status.value" :value="status.value">{{ status.name }}</option>
                            </select>
                        </div>
                        <div class="col-sm-3">
                            <span class="span-title">{{ $t('mixed_waste_bins.status') }}</span>
                            <select
                                id="binstatus"
                                v-model="bin.equipment_status_id"
                                class="form-select form-select-sm"
                            >
                                <option :value="null">{{ $t('mixed_waste_bins.choose_status') }}</option>
                                <option v-for="status in getInfraEquipmentStatus()" :key="status.value" :value="status.value">{{ status.name }}</option>
                            </select>
                        </div>
                        <div class="col-sm-3">
                            <span class="span-title">{{ $t('mixed_waste_bins.condition') }}</span>
                            <select
                                id="bincondition"
                                v-model="bin.equipment_condition_id"
                                class="form-select form-select-sm"
                            >
                                <option :value="null">{{ $t('mixed_waste_bins.choose_condition') }}</option>
                                <option v-for="status in getInfraEquipmentCondition()" :key="status.value" :value="status.value">{{ status.name }}</option>
                            </select>
                        </div>
                    </div>
                <div class="row">
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.waste_type') }}</span>
                        <select
                            id="wastetype"
                            v-model="bin.waste_type_id"
                            class="form-select form-select-sm"
                        >
                            <option :value="null">{{ $t('mixed_waste_bins.choose_waste_type') }}</option>
                            <option v-for="status in getMixedWasteBinWasteType()" :key="status.value" :value="status.value">{{ status.name }}</option>
                        </select>
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.inspection_interval') }}</span>
                        <select
                            id="interval"
                            v-model="bin.inspection_interval_id"
                            class="form-select form-select-sm"
                        >
                            <option :value="null">{{ $t('mixed_waste_bins.choose_inspection_interval') }}</option>
                            <option v-for="status in getMixedWasteBinInterval()" :key="status.value" :value="status.value">{{ status.name }}</option>
                        </select>
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.collection_int_winter') }}</span>
                        <input
                            id="collectionwinter"
                            v-model="bin.emptying_interval_weeks_summer"
                            type="number"
                            step="1"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.collection_int_summer') }}</span>
                        <input
                            id="collectionsummer"
                            v-model="bin.emptying_interval_weeks_winter"
                            type="number"
                            step="1"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('mixed_waste_bins.size') }}</span>
                        <input
                            id="size"
                            v-model="bin.size"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-3 pt-4">
                        <div class="form-check form-check-sm pt-2">
                            <input
                                id="pipeCollectionSystem"
                                v-model="bin.pipe_collection_system_switch"
                                class="form-check-input"
                                type="checkbox"
                            />
                            {{ $t('mixed_waste_bins.pipe_collection_system') }}
                        </div>
                    </div>
                    <div class="col-sm-3 pt-4">
                        <div class="form-check form-check-sm pt-2">
                            <input
                                id="onground"
                                v-model="bin.location_on_ground_surface_switch"
                                class="form-check-input"
                                type="checkbox"
                            />
                            {{ $t('mixed_waste_bins.location_on_ground') }}
                        </div>
                    </div>
                    <div class="col-sm-3 pt-4">
                        <div class="form-check form-check-sm pt-2">
                            <input
                                id="hazardouswaste"
                                v-model="bin.hazardous_waste_container_switch"
                                class="form-check-input"
                                type="checkbox"
                            />
                            {{ $t('mixed_waste_bins.hazardous_waste') }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span class="span-title">{{ $t('mixed_waste_bins.additional_info') }}</span>
                        <textarea
                            id="info"
                            v-model="bin.additional_info"
                            class="form-control form-control-sm"
                            :placeholder="$t('street_lights.info')"
                            rows="4"
                            style="resize: vertical;"
                        ></textarea>
                    </div>
                </div>

                <hr>
                <span
                    class="span-title"
                    style="text-transform: uppercase; font-size: .9em"
                >{{
                        $t('road_sign.contract_info')
                    }}</span>
                <louhi-multiple-contracts-filter
                    v-model="binContracts"
                    :editable="!loading"
                    :show-only-louhi-contracts="true"
                    style="margin-left: -2px; margin-right: -3px;"
                    @loading="loading = true"
                    @loading-completed="loading = false"
                    @contract-selected="setContract"
                />
                <div class="col-sm-12 d-flex justify-content-end pt-4 mt-2 pb-0 mb-0">
                    <button
                        :disabled="loading || bin===null"
                        class="btn btn-danger form-button"
                        @click.stop="removeBinModal = true"
                    >
                        {{ $t('mixed_waste_bins.waste_bin_remove') }}
                    </button>


                    <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
                        {{ $t('common.cancel') }}
                    </button>
                    <button class="btn btn-success form-button" :disabled="loading || bin === null" @click.stop="submit">
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
            <div v-if="loading" id="loader" class="spinner"></div>
        </div>
        <base-modal
            v-if="removeBinModal"
            hide-footer
            :title="$t('mixed_waste_bins.waste_bin_remove')"
        >
            <span>{{ $t('mixed_waste_bins.confirm_waste_bin_remove') }}</span>
            <div class="col-12 text-end mt-3">
                <button
                    class="btn btn-secondary form-button"
                    @click="removeBinModal = false"
                >
                    {{ $t('common.no') }}
                </button>
                <button
                    class="btn btn-success form-button"
                    @click="removeBin"
                >
                    {{ $t('common.yes') }}
                </button>
            </div>
        </base-modal>
    </base-modal>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import BaseModal from '../BaseModal'
import LouhiMultipleContractsFilter from "@/components/contract/external/LouhiMultipleContractsFilter.vue";
import {timeUtils} from "@/components/mixins/TimeUtils";
import {Pagination} from "@egjs/flicking-plugins";
import Flicking from "@egjs/vue3-flicking";
import "@egjs/flicking-plugins/dist/pagination.css";
import "@egjs/vue3-flicking/dist/flicking.css";
import {inject, toRaw} from "vue";
import {mixedWasteBinHelper} from "@/components/mixins/MixedWasteBinMixin.js";
import {infraEquipmentHelper} from "@/components/mixins/InfraEquipmentMixin.js";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'MixedWasteBinsWizard',
    components: {LouhiMultipleContractsFilter, EquipmentDate, Flicking, BaseModal},
    mixins: [restApi, timeUtils, mixedWasteBinHelper, infraEquipmentHelper],
    props: {
        selectedContract: {
            type: Object,
            default: null
        },
        coordinate: {
            type: Object,
            default: null
        },
        mixedWasteBin: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            bin: null,
            binContracts: [],
            basicInfoVisible: true,
            detailsVisible: true,
            wasteBinDetailsVisible: true,
            removeBinModal: false,
            position: null,
            plugins: [new Pagination({ type: 'bullet' })],
        }
    },
    computed: {
        fromDate() {
            if (this.bin.creation_date) {
                return this.bin.creation_date
            }
            let d = new Date()
            return d.toDateString()
        },
        toDate() {
            let d = new Date()
            return d.toISOString()
        }
    },
    emits: ['close', 'closeAndUpdate'],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        if (!this.mixedWasteBin) {
            this.bin = {
                id: null,
                is_deleted: null,
                metadata: null,
                identifaction_info: null,
                start_time: null,
                end_time: null,
                creation_date: null,
                modification_date: null,
                data_creator: null,
                modifier: null,
                model: null,
                renovation_year: null,
                direction: null,
                material_id: null,
                geom_polygon: null,
                geom_point: {
                    x: this.coordinate.lng,
                    y: this.coordinate.lat
                },
                geom_line: null,
                creation_method_id: null,
                location_uncertainty_id: null,
                owner: null,
                holder: null,
                maintainer: null,
                equipment_lifecycle_id: null,
                equipment_status_id: null,
                equipment_condition_id: null,
                additional_info: null,
                equipment_type: null,
                waste_type_id: null,
                size: null,
                pipe_collection_system_switch: null,
                location_on_ground_surface_switch: null,
                hazardous_waste_container_switch: null,
                emptying_interval_weeks_summer: null,
                emptying_interval_weeks_winter: null,
                inspection_interval_id: null,
                contract_ids: null,
                contracts: null
            }
        } else {
            this.bin = toRaw(this.mixedWasteBin)
            if(this.bin.contracts){
                this.binContracts = this.bin.contracts
            }
        }
        //either we have geom_point defined by the coordinate, prop coordinate via null instantiation and to geom_point
        //then we have data in geom_point --> show position variable on the UI
        const gp = this.bin?.geom_point
        if(gp?.x != null && gp?.y != null) {
            this.position = {lat: this.bin.geom_point.x, lng: this.bin.geom_point.y}
        }

    },
    methods: {
        submit: function () {
            this.loading = true
            //called via map add
            if (this.coordinate) {
                this.bin.geom_point = {
                    y: this.coordinate.lat,
                    x: this.coordinate.lng
                }
            }
            this.bin.contract_ids = this.normalizeIds(this.binContracts)
            if (this.bin?.id ) {
                this.restUpdate(this.mixedWasteBinUrl, this.bin, this.success, this.fail)
            } else {
                this.restAdd(this.mixedWasteBinUrl, this.bin, this.success, this.fail)
            }
        },
        success: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_add_failed'))
        },
        setContract: function (contract) {
            //TODO: fix is this required at all?
          //  this.contract = contract
        },
        removeBin() {
            this.loading = true
            this.removeBinModal = false
            const LOUHI_TYPE = 'jate';
            this.restDelete(this.extLouhiEquipmentUrl + '/' + LOUHI_TYPE + '/' + this.bin.id, this.success, this.fail)
        }
    }
}
</script>
<style>
@import "../../styles/modal.css";
</style>
